import axios from 'axios'

export const checkConnection = {
	namespaced: true,
	state: {
		loading: false
	},
	getters: {
		loading: (state) => state.loading
	},
	mutations: {
		prepareConnect(state) {
			state.loading = true
		},
		stopLoading(state) {
			state.loading = false
		}
	},
	actions: {
		async checkConnection({ commit }, payload) {
			commit('prepareConnect')

			const { requestData, accessToken } = payload
			const { studentId, teacherId } = requestData

			const header = {
				headers: {
					Authorization: `Bearer ${accessToken}`
				}
			}
			const requestBody = {
				studentId,
				teacherId
			}
			return axios
				.post(`/api/regularSchedules/checkConnection`, requestBody, header)
				.then((res) => {
					return res.data.hasConnection
				})
				.catch((err) => {
					console.log(err)
					return false
				})
				.finally(() => {
					commit('stopLoading')
				})
		}
	}
}
